import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CONFIG } from '../core/config';
import { AnonymousUserModel } from '../core/models/anonymous-user-login/anonymous-user.model';
import { LoggedInUserModel } from '../core/models/logged-in-user.model';
import { UserCredentialsModel } from '../core/models/registered-user-login/user-credentials.model';
import { ExceptionService } from '../core/services/exception.service';
import { SpinnerService } from '../core/spinner/spinner.service';
import { ForgottenUsernamePasswordModel } from '../core/models/user-basic-data/forgotten-username-password';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    registeredUserLogin(loginModel: UserCredentialsModel): Observable<LoggedInUserModel> {
        this._spinnerService.show();
        return this._http.post<LoggedInUserModel>(CONFIG.baseUrls.registeredUserLogin, loginModel)
            .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
            );
    }

    anonymousUserLogin(loginModel: AnonymousUserModel): Observable<LoggedInUserModel> {
        this._spinnerService.show();
        return this._http.post<LoggedInUserModel>(CONFIG.baseUrls.anonymousUserLogin, loginModel)
            .pipe(
            catchError(this._exceptionService.catchBadResponse),
            finalize(() => this._spinnerService.hide())
            );
    }

    forgottenUsernamePassword(user: ForgottenUsernamePasswordModel): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.forgottenUsernamePassword, user)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    //getAdditionalAccessRight(): Observable<number[]> {
    //     this._spinnerService.show();
    //    return this._http.get<number[]>(CONFIG.baseUrls.getAdditionalAccessRights)
    //        .pipe(
    //        catchError(this._exceptionService.catchBadResponse),
    //        finalize(() => this._spinnerService.hide())
    //        );
    //}
}
